import { Button } from "design-system/atoms/Button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "design-system/atoms/Dialog"
import { useDeleteAmphoraIntegrationMutation } from "modules/settings/hooks/amphora/useDeleteAmphoraIntegrationMutation"
import { useTranslation } from "react-i18next"

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
  onDeleted: () => void
}

export const DeleteAmphoraIntegration = ({ open, onOpenChange, onDeleted }: Props) => {
  const { t } = useTranslation()
  const { mutateAsync, isPending } = useDeleteAmphoraIntegrationMutation()

  const onDelete = async () => {
    await mutateAsync()
    onOpenChange(false)
    onDeleted()
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t("settings.integrations.amphora.integrationCard.deleteIntegration.title")}
          </DialogTitle>
          <DialogDescription>
            {t("settings.integrations.amphora.integrationCard.deleteIntegration.description")}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="secondary" onClick={() => onOpenChange(false)} disabled={isPending}>
            {t("settings.integrations.amphora.integrationCard.deleteIntegration.actions.cancel")}
          </Button>
          <Button variant="destructive" onClick={onDelete} disabled={isPending}>
            {t("settings.integrations.amphora.integrationCard.deleteIntegration.actions.delete")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
